import { TGlobalStores } from '@/editor/stores';
import { CommonController2d } from '../CommonController';
import { rayIntersect } from '../operateEntityController/rayIntersect';
import { calMousePosition } from '@/editor/utils';
import * as THREE from 'three';
import { modelManager } from '@/editor/manager/entityManager';
import { isSelectAlignReferenceEntity } from './utils';

type IIntersectedEntity = ReturnType<typeof rayIntersect.rayEntities>[number];

export class OperateAlignment extends CommonController2d {
  private readonly mouseButton = { LEFT: 0, MIDDLE: 1, RIGHT: 2 };
  private _mousePosition: THREE.Vector2 = new THREE.Vector2();
  private _intersectedEntity: IIntersectedEntity | null = null;
  private _previousHoverEntity: IIntersectedEntity | null = null;
  private _prevSelectedEntity: IIntersectedEntity | null = null;

  constructor(globalStores: TGlobalStores) {
    super(globalStores);
  }

  override init() {
    super.init();
  }

  private _updateHoverEntity() {
    if (
      this._intersectedEntity &&
      this._intersectedEntity.entityId !== this._previousHoverEntity?.entityId &&
      isSelectAlignReferenceEntity(this._intersectedEntity)
    ) {
      this._gs.editorStateStore.setHoverEntity(this._intersectedEntity);
    } else if (
      !this._intersectedEntity ||
      (this._intersectedEntity && !isSelectAlignReferenceEntity(this._intersectedEntity))
    ) {
      this._gs.editorStateStore.clearHoverEntity();
    }
  }

  private _setIntersectedEntity(entity: IIntersectedEntity | null) {
    this._previousHoverEntity = this._intersectedEntity;
    this._intersectedEntity = entity;
  }

  private _intersectEntity = () => {
    const intersectedEntities = rayIntersect.rayEntities(this._mousePosition);

    if (intersectedEntities[0]) {
      this._setIntersectedEntity(intersectedEntities[0]);
    } else {
      this._setIntersectedEntity(null);
    }
  };

  protected override mouseUp = (e: MouseEvent, isDragged: boolean) => {
    if (!isDragged && e.button === this.mouseButton.RIGHT) {
      this._gs.alignOperation.toggleAlignModeEnabled(false);
      return;
    }

    if (isDragged || e.button !== this.mouseButton.LEFT) return;

    this._mousePosition = calMousePosition(e, this._domElement);
    this._intersectEntity();
    if (
      this._intersectedEntity &&
      this._intersectedEntity.entityId === this._previousHoverEntity?.entityId &&
      isSelectAlignReferenceEntity(this._intersectedEntity)
    ) {
      modelManager.alignManager.updateAlignReference(this._intersectedEntity);
    }
  };

  protected override mouseDown = (e: MouseEvent) => {
    if (e.button !== this.mouseButton.LEFT) {
      return;
    }

    // modelManager.alignManager.updateAlignReference();

    this._mousePosition = calMousePosition(e, this._domElement);
  };

  protected override mouseMove = (e: MouseEvent) => {
    this._mousePosition = calMousePosition(e, this._domElement);
    this._intersectEntity();
    this._updateHoverEntity();
  };

  override dispose() {
    modelManager.alignManager.updateAlignReference();
    super.dispose();
  }
}
